import { render } from "./UploadTokensForm.vue?vue&type=template&id=6d37a50b"
import script from "./UploadTokensForm.vue?vue&type=script&lang=js"
export * from "./UploadTokensForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__